var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-candidate-portal-page"},[_c('iframe',{staticClass:"new-candidate-portal-frame",attrs:{"src":"/new-candidate-portal.html","title":"TalentFind Candidate Portal - Hybrid Dashboard V3"}})])
}]

export { render, staticRenderFns }